export const AppUrls = {
     //_baseUrl: "http://localhost:57833/api/IronParts/"
    _baseUrl: "https://api.gcironparts.com/api/IronParts/"
  //  _baseUrl: "http://api.gcironpartsdev.com/api/IronParts/"
};
// "http://gcironparts.technodemos.com/api/IronParts/GetSubSystemByProduct";